export const AP_SALESFORCE = 'salesforce';
// export const FACEBOOK = 'facebook';
export const AP_GOOGLE = 'google';

export type AuthProvider = (
  | typeof AP_SALESFORCE
  | typeof AP_GOOGLE
);
